// HOLDOUTGROUP : holdout-darwinspets-26q1

// function to check holdout group and add class ab-enabled
const checkHoldout = _ => {
  const holdoutGroup = window._growthbook?.getFeatureValue('holdout-darwinspets-26q1', 'OFF');

  if (holdoutGroup != 'holdout-darwinspets-26q1') {
    document.documentElement.classList.add("ab-enabled");
    window.ab_enabled = true;
  }
};

// Feature Flag Key : top-nav-best-sellers
const bestSellersTest = () => {
  const holdoutGroup = window._growthbook?.getFeatureValue('holdout-darwinspets-25q4', 'OFF');

  if (holdoutGroup === 'holdout-darwinspets-25q4') return;

  const bestSellersTestEnabled = true;

  if (bestSellersTestEnabled) {
    const header = document.getElementById("header-darwins");
    header ? header.classList.add("best-sellers-enabled") : null; 
  }
};

// Feature Flag Key : mobile-carousel
const mobileCarouselTest = () => {
  const mobileCarouselEnabled = true;

  if (mobileCarouselEnabled) {
    const mobileCategorySection = document.querySelector(".carousel-homepage");
    
    mobileCategorySection ? mobileCategorySection.classList.add("mobileCarouselEnabled") : null;
  }
};

// Feature Flag Key : sticky-atc-darwins
const stickyAtcTest = () => {
  const holdoutGroup = window._growthbook?.getFeatureValue('holdout-darwinspets-25q4', 'OFF');
  if (holdoutGroup === 'holdout-darwinspets-25q4') return;

  const stickyAtcEnabled = true; // Variant Winner

  if (stickyAtcEnabled) {
    const stickyCart = document.querySelector(".sticky-cart-mobile.test-sticky-cart");

    if (stickyCart) stickyCart.classList.remove("test-sticky-cart");
  }
};

// Feature Flag Key : most-popular 
const mostPopularTest = () => {
  const holdoutGroup = window._growthbook?.getFeatureValue('holdout-darwinspets-25q4', 'OFF');

  if (holdoutGroup === 'holdout-darwinspets-25q4') return;

  if (!document.querySelector('script[src*="change-best-sellers-text.js"]')) {
    const scriptUrl = window.pdmAssets?.changeBestSellersText;
    if (scriptUrl) {
      const script = document.createElement('script');
      script.src = scriptUrl;
      script.defer = true;
      document.head.appendChild(script);
    }
  }
};

// Feature Flag Key : pdp-tags-test
const pdpTagsTest = () => {
  const holdoutGroup = window._growthbook?.getFeatureValue('holdout-darwinspets-26q1', 'OFF');

  if (holdoutGroup === 'holdout-darwinspets-26q1') return;

  const pdpTagsEnabled = true; // 

  if (pdpTagsEnabled) {
    const tagsElement = document.querySelector(".tags-test");
    if (tagsElement) tagsElement.classList.remove("tags-test");
  }
};

// Feature Flag Key : quiz-pdp
const quizPdpTest = () => {
  const holdoutGroup = window._growthbook?.getFeatureValue('holdout-darwinspets-26q1', 'OFF');

  if (holdoutGroup === 'holdout-darwinspets-26q1') return;

  const quizPdpEnabled = true; 

  window.quizPdpEnabled = quizPdpEnabled;
};

// Feature Flag Key : truspilot-test
const trustpilotTest = () => {
  const holdoutGroup = window._growthbook?.getFeatureValue('holdout-darwinspets-26q1', 'OFF');

  if (holdoutGroup === 'holdout-darwinspets-26q1') return;

  const trustpilotEnabled = true; 

  if (trustpilotEnabled) {
    const reviewsSection = document.querySelector(".customer-reviews-section.reviews-section");
    if (reviewsSection) {
      reviewsSection.classList.remove("reviews-section");
    }
  }
};

(() => {
  window.growthbook_queue = window.growthbook_queue || [];
  window.growthbook_queue.push((gb) => {
    // Function that uses feature flags to make changes to the page
    const applyFeatureFlags = () => {
      bestSellersTest();
      mobileCarouselTest();
      stickyAtcTest();
      mostPopularTest();
      pdpTagsTest();
      quizPdpTest();
      trustpilotTest();
    };

    // check holdout to set ab test
    checkHoldout();

    // Call your function initially plus whenever new data is received
    applyFeatureFlags(); 
    document.addEventListener("growthbookdata", _ => {
      checkHoldout();
      applyFeatureFlags();
    });
  });
})();